import { render, staticRenderFns } from "./OptInRule.vue?vue&type=template&id=3734722a&"
import script from "./OptInRule.vue?vue&type=script&lang=js&"
export * from "./OptInRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports